module.exports = __webpack_public_path__ + "img/Pic-mhd.1a00d7a6.png";